import React from 'react'
import PageTransition from 'gatsby-plugin-page-transitions'

import './index.css'

import {
  Measurements,
  Services,
  BigLink,
  Founded,
  Automatization,
  Accreditation,
  References,
} from '../components'

const IndexPage = () => (
  <PageTransition>
    <div className="index-measurements-wrapper">
      <div className="">
        <div className="row">
          <div className="col-lg-4 offset-lg-8 col-md-4 offset-md-8 index-measurement-background" />
        </div>
      </div>
      <div className="container">
        <Measurements />
      </div>
    </div>
    <div className="container index-founded-wrapper">
      <Founded />
    </div>
    <div className="container index-services-wrapper">
      <Services />
    </div>
    <div className="container index-accreditation-wrapper">
      <Accreditation />
    </div>
    <div className="container index-automatization-wrapper">
      <Automatization />
    </div>
    <div className="index-references-wrapper">
      <div className="container">
        <References />
      </div>
    </div>
    <div className="index-first-link">
      <BigLink
        to="/proizvodi"
        title="Proizvodi"
        subtitle="Pogledajte što nudimo"
      />
    </div>
    <BigLink to="/kontakt" title="Javite se" subtitle="Znate što želite" />
  </PageTransition>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js